import React from "react";

import ListCollapse from "../ListCollapse";

import "./style.scss";

function KPIs({
  title,
  selectable,
  data = [],
  selectedItem,
  onItemSelect,
  getIsSelected,
  getTitle,
  childrenKey,
  apiKey,
  onUpdate,
  getHeaderTitle,
  handleEqualOnClick = () => {},
}) {
  return (
    <div className="weight-kpis__so">
      <div className="weight-kpis__so__content">
        {data?.map((e, i) => (
          <ListCollapse
            key={e?.ID}
            title={i === 0 ? title : ""}
            item={e}
            selectable={selectable}
            selectedItem={selectedItem}
            onItemSelect={onItemSelect}
            getIsSelected={getIsSelected}
            getTitle={getTitle}
            childrenKey={childrenKey}
            getHeaderTitle={getHeaderTitle}
            apiKey={apiKey}
            onUpdate={onUpdate}
            handleEqualOnClick={handleEqualOnClick}
          />
        ))}
      </div>
    </div>
  );
}

export default KPIs;
